import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      <SEO 
        title="Page Not Found | RESILIGENT"
        description="The page you're looking for doesn't exist. Return to RESILIGENT's homepage to explore our leadership development and executive coaching services."
        canonical="/404"
      />
      
      <Header />
      
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-2xl mx-auto text-center">
          {/* 404 Number with gradient */}
          <div className="relative mb-8">
            <h1 className="text-[150px] sm:text-[200px] font-bold leading-none text-transparent bg-clip-text bg-gradient-to-br from-[#2693d0] via-[#0D7CB4] to-[#1a3a5c] select-none">
              404
            </h1>
            <div className="absolute inset-0 text-[150px] sm:text-[200px] font-bold leading-none text-[#2693d0]/10 blur-2xl select-none" aria-hidden="true">
              404
            </div>
          </div>
          
          {/* Message */}
          <h2 className="text-white text-2xl sm:text-3xl font-semibold mb-4">
            Page Not Found
          </h2>
          <p className="text-slate-400 text-base sm:text-lg mb-10 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link 
              to="/"
              className="inline-flex items-center gap-2 bg-[#2693d0] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#1e7ab8] transition-colors duration-300"
            >
              <Home size={18} />
              Back to Homepage
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 bg-white/10 text-white px-6 py-3 rounded-lg font-medium hover:bg-white/20 transition-colors duration-300 border border-white/20"
            >
              <ArrowLeft size={18} />
              Go Back
            </button>
          </div>
          
          {/* Quick Links */}
          <div className="mt-16 pt-10 border-t border-white/10">
            <p className="text-slate-500 text-sm mb-6">Or explore these popular pages:</p>
            <div className="flex flex-wrap justify-center gap-3">
              {[
                { label: 'About Us', href: '/about' },
                { label: 'Our People', href: '/our-people' },
                { label: 'Services', href: '/diagnostics' },
                { label: 'Case Studies', href: '/case-studies' },
                { label: 'Contact', href: '/contact' },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-slate-400 text-sm hover:text-[#2693d0] transition-colors duration-300 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      
      <Footer hidePreFooterCta={true} />
    </div>
  );
};

export default NotFoundPage;
